import { useRequest } from '@features/request/useRequest';
import { useResetStoreData } from '@features/request/useResetStoreData';
import type { CatalogRatioMassApplyInput } from '@gql/graphql';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogRatioMassApplyGql } from '../massRatioApplicationQueries';

export const useMassApplyRatios = ({ onSuccessAction }: { onSuccessAction: () => void }) => {
    const dispatch = useDispatch();

    const [resetRemoveData] = useResetStoreData({ requestId: 'massApplyRatios' });

    const tempSuccessHandler = useCallback(() => {
        onSuccessAction();
        resetRemoveData(undefined);
    }, [resetRemoveData, onSuccessAction]);

    const [, , , massApplyRatiosRequest] = useRequest({
        requestId: 'massApplyRatios',
        query: catalogRatioMassApplyGql,
        withEffect: false,
        dependenciesUpdater: tempSuccessHandler,
    });

    const massApplyHandler = useCallback(
        (input: CatalogRatioMassApplyInput) => {
            dispatch(massApplyRatiosRequest({ input }));
        },
        [dispatch, massApplyRatiosRequest],
    );

    return useMemo(
        () => ({
            massApplyHandler,
        }),
        [massApplyHandler],
    );
};
